import { z } from 'zod';

/**
 * Task #3819 — Connettori MCP custom (admin-gated): DTO di risposta condivisi
 * BE↔FE per sync/discovery e test-connection. Fonte di verità unica (Zod +
 * z.infer), mai tipi locali FE (gate check-response-dto-shared).
 */

/** Tool scoperto e persistito da POST /mcp/servers/:id/sync (con policy seedata). */
export const mcpSyncedToolSchema = z.object({
  tool_name: z.string(),
  description: z.string(),
  /** Policy iniziale seedata in mcp_tool_permissions (classifyMcpTool). */
  allowed: z.boolean(),
  require_confirmation: z.boolean(),
});
export type McpSyncedTool = z.infer<typeof mcpSyncedToolSchema>;

/** `data` di POST /mcp/servers/:id/sync per server custom (non internal-global). */
export const mcpCustomSyncResponseSchema = z.object({
  tool_count: z.number().int().nonnegative(),
  tools: z.array(mcpSyncedToolSchema),
});
export type McpCustomSyncResponse = z.infer<typeof mcpCustomSyncResponseSchema>;

/** `data` di POST /mcp/test-connection (campi presenti a seconda del transport). */
export const mcpTestConnectionResponseSchema = z.object({
  tools_found: z.number().int().nonnegative().optional(),
  server_name: z.string().optional(),
  server_version: z.string().optional(),
  message: z.string().optional(),
});
export type McpTestConnectionResponse = z.infer<typeof mcpTestConnectionResponseSchema>;
